<template>
  <div class="main-layout">
    <!-- 侧边栏 -->
    <aside class="sidebar">
      <div class="sidebar-logo">
        <img v-if="userInfo.logoUrl" :src="userInfo.logoUrl" class="logo-img" />
        <div v-else class="logo-icon">W</div>
        <div>
          <div class="logo-text">{{ userInfo.displayName || '无界有品' }}</div>
          <div class="logo-sub">商家端</div>
        </div>
      </div>
      <el-menu
        :default-active="activeMenu"
        :unique-opened="true"
        background-color="#001529"
        text-color="#ffffffb3"
        active-text-color="#52c41a"
        router
        class="sidebar-nav"
      >
        <!-- 首页 -->
        <el-menu-item v-if="can('home')" index="/home">
          <i class="el-icon-s-home"></i>
          <span>首页</span>
        </el-menu-item>

        <!-- 客户订单 -->
        <el-submenu v-if="can('orders') || can('orders:create') || can('tracking')" index="orders-group">
          <template slot="title">
            <i class="el-icon-s-order"></i>
            <span>客户订单</span>
          </template>
          <el-menu-item v-if="can('orders')" index="/orders">
            <span>订单管理</span>
          </el-menu-item>
          <el-menu-item v-if="can('orders:create')" index="/orders/create">
            <span>创建订单</span>
          </el-menu-item>
          <el-menu-item v-if="can('orders:create')" index="/orders/batch">
            <span>批量下单</span>
          </el-menu-item>
          <el-menu-item v-if="can('tracking')" index="/tracking">
            <span>轨迹查询</span>
          </el-menu-item>
        </el-submenu>

        <!-- 财务管理 -->
        <el-submenu v-if="can('credit-audit') || can('fees') || !isMainAccount" index="finance-group">
          <template slot="title">
            <i class="el-icon-money"></i>
            <span>财务管理</span>
          </template>
          <el-menu-item v-if="can('credit-audit') || !isMainAccount" index="/credit-audit">
            <span>余额与额度</span>
          </el-menu-item>
          <el-menu-item v-if="can('fees') && !isTTWL" index="/fees">
            <span>费用查询</span>
          </el-menu-item>
          <el-menu-item v-if="isMainAccount" index="/sub-account-receivable">
            <span>子账户应收</span>
          </el-menu-item>
          <el-menu-item v-if="can('fees') || !isMainAccount" index="/sub-account-fees">
            <span>子费用查询</span>
          </el-menu-item>
          <el-menu-item v-if="can('credit-audit') || !isMainAccount" index="/sub-account-audits">
            <span>子审核记录</span>
          </el-menu-item>
          <el-menu-item v-if="can('credit-audit') || !isMainAccount" index="/balance-records">
            <span>余额明细</span>
          </el-menu-item>
        </el-submenu>

        <!-- 报价管理 -->
        <el-submenu v-if="isMainAccount" index="pricing-group">
          <template slot="title">
            <i class="el-icon-s-order"></i>
            <span>报价管理</span>
          </template>
          <el-menu-item index="/pricing/zones">
            <span>子分区设置</span>
          </el-menu-item>
          <el-menu-item index="/pricing/weights">
            <span>子重量段设置</span>
          </el-menu-item>
          <el-menu-item index="/pricing/fee-types">
            <span>子费用类型</span>
          </el-menu-item>
          <el-menu-item index="/pricing/freights">
            <span>子运费设置</span>
          </el-menu-item>
        </el-submenu>

        <!-- 系统管理 -->
        <el-submenu v-if="can('system:roles') || can('system:users') || can('profile') || can('keys')" index="system-group">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>系统管理</span>
          </template>
          <el-menu-item v-if="can('system:roles')" index="/system/roles">
            <span>角色管理</span>
          </el-menu-item>
          <el-menu-item v-if="can('system:users')" index="/system/users">
            <span>用户管理</span>
          </el-menu-item>
          <el-menu-item v-if="can('profile')" index="/profile">
            <span>个人信息</span>
          </el-menu-item>
          <el-menu-item v-if="can('keys')" index="/keys">
            <span>密钥管理</span>
          </el-menu-item>
        </el-submenu>

        <!-- 平台管理 -->
        <el-submenu v-if="can('system:bindings')" index="platform-group">
          <template slot="title">
            <i class="el-icon-connection"></i>
            <span>平台管理</span>
          </template>
          <el-menu-item index="/system/bindings">
            <span>平台绑定</span>
          </el-menu-item>
        </el-submenu>

        <!-- API对接文档 -->
        <el-menu-item v-if="can('api-docs')" index="/api-docs">
          <i class="el-icon-document"></i>
          <span>API对接文档</span>
        </el-menu-item>
      </el-menu>
    </aside>

    <!-- 主内容区 -->
    <div class="main-area">
      <header class="top-bar">
        <div class="header-left">{{ currentPageTitle }}</div>
        <div class="header-right">
          <span class="user-name" v-if="userInfo.subAccountName">
            {{ userInfo.subAccountName }}
            <span style="color:#8c8c8c;font-size:12px">@ {{ userInfo.realName || userInfo.username }}</span>
          </span>
          <span class="user-name" v-else>{{ userInfo.realName || userInfo.username }}</span>
          <el-dropdown trigger="click">
            <span class="el-dropdown-link" style="cursor:pointer">
              <el-avatar size="small" :src="userInfo.avatar" icon="el-icon-user-solid"></el-avatar>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="goProfile">个人信息</el-dropdown-item>
              <el-dropdown-item divided @click.native="handleLogout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  computed: {
    userInfo() {
      return this.$store.state.userInfo || {}
    },
    menus() {
      return this.$store.state.menus || []
    },
    activeMenu() {
      return this.$route.path
    },
    currentPageTitle() {
      return this.$route.meta.title || ''
    },
    isMainAccount() {
      return !(this.userInfo && this.userInfo.subAccountId)
    },
    isTTWL() {
      return !!(this.userInfo && this.userInfo.customerCode === 'TTWL')
    }
  },
  methods: {
    can(perm) {
      return this.$store.getters.hasPermission(perm)
    },
    goProfile() {
      this.$router.push('/profile')
    },
    handleLogout() {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.main-layout { display: flex; height: 100vh; }
.sidebar {
  width: 220px; background: #001529; display: flex; flex-direction: column; flex-shrink: 0;
  box-shadow: 2px 0 8px rgba(0,0,0,0.15); z-index: 100;
}
.sidebar-logo {
  padding: 16px 20px; border-bottom: 1px solid rgba(255,255,255,0.08);
  display: flex; align-items: center; gap: 10px;
}
.logo-icon {
  width: 36px; height: 36px; background: #52c41a; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-weight: 700; font-size: 16px;
}
.logo-img {
  width: 36px; height: 36px; border-radius: 8px; object-fit: contain;
}
.logo-text { font-size: 16px; font-weight: 600; color: #fff; }
.logo-sub { font-size: 11px; color: rgba(255,255,255,0.45); }
.sidebar-nav { flex: 1; overflow-y: auto; border-right: none; }

/* Dark sidebar override */
.sidebar-nav .el-submenu__title { color: #ffffffb3; }
.sidebar-nav .el-submenu__title:hover { background: rgba(255,255,255,0.04); color: #fff; }
.sidebar-nav .el-menu-item {
  color: #ffffffb3; background: #001529;
  min-width: 0;
}
.sidebar-nav .el-menu-item:hover { background: rgba(255,255,255,0.04); color: #fff; }
.sidebar-nav .el-menu-item.is-active { color: #52c41a; background: #002140; }
.sidebar-nav .el-menu { background: #000c17; }

.main-area { flex: 1; display: flex; flex-direction: column; min-width: 0; }
.top-bar {
  height: 56px; background: #fff; border-bottom: 1px solid #f0f0f0;
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 24px; flex-shrink: 0;
}
.header-left { font-size: 16px; font-weight: 600; }
.header-right { display: flex; align-items: center; gap: 16px; }
.user-name { font-size: 13px; color: #595959; }
.content { flex: 1; padding: 20px 24px; overflow-y: auto; }
</style>
